import { useContext, useEffect, useMemo, useState } from 'react';
import { BranchOperation } from '../../../../serviceoperation/BranchOperation';
import { CompanyContext } from '../../../../contexts/company-context';
import { AuthenticationContext } from '../../../../contexts/authentication-context';
import type { Location } from "../../../../types/location";
import { name } from '@azure/msal-browser/dist/packageMetadata';

export const useLocations = (searchQuery: string, filterState: string, refreshData: boolean) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { selectedCompany } = useContext(CompanyContext);
  const userInfo = useContext(AuthenticationContext)?.userInfo;
  const [locations, setLocations] = useState<Location[]>([]);

  
  const states = useMemo(() => 
    Array.from(new Set(locations.map(loc => loc.state))).sort(),
    [locations]
  );

  // Need to make sure we implement Locations pagination, 
  // currently this isn't being done so it could cause some performance issues.
  useEffect(() => {
    setLoading(true);
    const branchOps = new BranchOperation();
    branchOps
      .getBranchAsync(selectedCompany?.corporationId as number)
      .then((value) => {
        setLocations(
          value!.data!.map((branch) => ({
            id: branch.branchID.toString(),
            name: branch.name,
            description: branch.description,
            address: branch.address.line1,
            city: branch.address.city,
            state: branch.address.state,
            zipCode: branch.address.zip.toString(),
            color: branch.color,
            timezone: branch.timeZoneId,
            departments: branch.departments.map((dept) =>({
              id: dept.id,
              name: dept.name
            })),
          }))
        );
        setLoading(false);
      });
  }, [userInfo,refreshData]);

  const filteredLocations = useMemo(() =>
    locations.filter(
      location => 
        location.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
        (!filterState || location.state === filterState)
    ),
    [searchQuery, filterState,locations]
  );

  return {
    locations: filteredLocations,
    states,
    loading,
    totalLocations: filteredLocations.length
  };
};